import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

export default function PageTransition({ children }: Props) {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState<'enter' | 'exit'>('enter');

  useEffect(() => {
    if (location.pathname !== displayLocation.pathname) {
      setTransitionStage('exit');
    }
  }, [location, displayLocation]);

  const handleTransitionEnd = () => {
    if (transitionStage === 'exit') {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
      setDisplayLocation(location);
      setTransitionStage('enter');
    }
  };

  return (
    <div
      className={transitionStage === 'enter' ? 'page-fade-in' : 'page-fade-out'}
      onAnimationEnd={handleTransitionEnd}
    >
      {children}
    </div>
  );
}
